module.exports = __webpack_public_path__ + "img/add-field.4caa3333.svg";